<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" placeholder="搜索名称" />
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="24">
            <a-form-item label="状态">
              <a-select v-model="queryParam.status" placeholder="请选择" allowClear>
                <a-select-option value="1">未处理</a-select-option>
                <a-select-option value="2">处理中</a-select-option>
                <a-select-option value="3">处理完成</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
            >
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <a-modal
        :maskClosable="false"
      title="操作"
      :width="1000"
      style="top: 20px;"
      :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
      v-model="visible"
      @ok="handleOk"
    >
    <a-spin :spinning="spinning">

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="用户" hasFeedback>
          <span v-if="formData.niming==2">{{formData.user_name}} {{formData.user_phone}}</span>
          <span v-else>（匿名）</span>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="业务板块" hasFeedback>
          <span >{{formData.type_name}}</span> 
        </a-form-item> 
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="内容" hasFeedback>
          {{formData.content}}
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="管理员备注" hasFeedback>
          <a-textarea
            style="height:200px"
            v-decorator="['serviceNote',{rules: []}]"
            placeholder
            v-model="adminNote"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="处理状态" hasFeedback>
          <a-radio-group @change="onChange" v-model="value">
            <a-radio :style="radioStyle" :value="1">未处理</a-radio>
            <a-radio :style="radioStyle" :value="2">处理中</a-radio>
            <a-radio :style="radioStyle" :value="3">处理完成</a-radio>
          </a-radio-group>
        </a-form-item>
        </a-spin>
        <template slot="footer">
          <a-button key="cancel" @click="handleCancel">取消</a-button>
          <a-button
            key="forward"
            :loading="saveLoading"
            type="primary"
            @click="handleOk(formData)"
          >保存</a-button>
        </template>

    </a-modal>

    <div class="table-operator">
      <!-- <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="setAllStatus(1)" key="1">
            <a-icon type="upload" />未处理
          </a-menu-item>
          <a-menu-item @click="setAllStatus(2)" key="2">
            <a-icon type="download" />处理中
          </a-menu-item>
          <a-menu-item @click="setAllStatus(3)" key="3">
            <a-icon type="download" />已处理
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown> -->
    </div>

    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <span slot="name" slot-scope="name,record"> 
        <div v-if="record.niming==2">
        {{record.user_name}}
        <br />
        {{record.user_phone}}</div>
        <div v-else>(匿名)</div>
        <br />
        {{record.create_time|timeFormat}}
      </span>
      <span slot="type_name" slot-scope="text,record">
        <span >{{record.type_name}}</span>
        <br /> 
        <span v-if="record.status==1" style="color:green">未处理</span>
        <span v-if="record.status==2" style="color:red">处理中</span>
        <span v-if="record.status==3" style="color:#cccccc">处理完成</span>
      </span>
      <span slot="content" slot-scope="text,record">
        <span>{{record.content}}</span>
      </span>
      <span slot="adminnote" slot-scope="text,record">
        <span>{{record.adminnote}}</span>
      </span>
      <span slot="action" slot-scope="text,record">
        <template>
          <a href="javascript:;" @click="HandelStatus(record)">操作</a>

          <!-- <a-divider type="vertical" v-if="record.status==3" /> -->
          <!-- <a-popconfirm title="确定删除该条素材吗?" @confirm="setDelete(record)" okText="确定" cancelText="取消">
            <a href="javascript:;">删除</a>
          </a-popconfirm>-->
        </template>
      </span>
    </s-table>
  </a-card>
</template>


<script>
import STable from '@/components/table/'
import ATextarea from 'ant-design-vue/es/input/TextArea'
import AInput from 'ant-design-vue/es/input/Input'
import EditableCell from '@/components/EditableCell/'
import RSwitch from '@/components/RSwitch/'
import PicUploader from '@/components/PicUploader/'
import PriceInput from '@/components/PriceInput/'
import moment from 'moment'

import { gbookList, gbookEdit } from '@/api/gbook'
import { truncate } from 'fs';
export default {
  name: 'businessForm',
  components: {
    AInput,
    ATextarea,
    STable,
    EditableCell,
    RSwitch,
    PriceInput,
    PicUploader
  },
  data() {
    return {
      value: 1,
      radioStyle: {
        height: '30px',
        lineHeight: '30px'
      },

      adminNote: '',
      setRewardsPrice: {
        setRewardsPrice: 366
      },
      visible: false,
      saveLoading: false,
      userVisible: false,
      spinning: false,
      formData: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      form: this.$form.createForm(this),
      mdl: {},

      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        keywords: ''
      },
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: 'id',
          width: '50px'
        },
        {
          width: '200px',
          title: '用户',
          dataIndex: 'user_name',
          scopedSlots: { customRender: 'name' }
        },
        {
          title: '业务板块',
          dataIndex: 'type_name',
          scopedSlots: { customRender: 'type_name' }
        },
        {
          title: '建议内容',
          dataIndex: 'content',
          scopedSlots: { customRender: 'content' }
        },
        {
          title: '管理员备注',
          dataIndex: 'adminnote',
          scopedSlots: { customRender: 'adminnote' }
        },
        {
          title: '审核操作',
          dataIndex: 'action',
          width: '180px',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log('loadData')
        console.log(this.queryParam)
        this.queryParam = Object.assign(this.queryParam, parameter)

        return gbookList(this.queryParam).then(res => {
          console.log('res')
          return res.data
        })
      },

      selectedRowKeys: [],
      selectedRows: [],
      goodsOptions: []
    }
  },
  computed: {
    pen_price: function() {
      var result = 0
      for (var i = 0; i < this.formData.pen_data.length; i++) {
        result += parseFloat(this.formData.pen_data[i].amount)
      }
      return result
    }
  },
  created() {},
  mounted() {
    let that = this
  },
  methods: {
    moment,
    handleCancel() {
      this.visible = false
    },
    HandelStatus(record) {
      console.log(record)
      this.visible = true
      this.formData = record
      this.value = record.status
      this.adminNote = record.adminnote
    },
    onChange(e) {
      this.value = e.target.value
      console.log(this.value)
    },
    //处理咨询 增加备注
    handleOk(record) {
      let that = this
      let note = that.adminNote
      that.spinning=true
      console.log(record)
      gbookEdit({ id: record.id, status: that.value, adminNote: note })
        .then(res => {
          that.spinning=false
          that.$message.success('操作成功')
          that.$refs.table.refresh()
          this.visible = false


          this.loadData
        })
        .catch(err => {
          that.$message.error(err.data.msg)
        })
    },

    // 查
    onSearch() {
      let self = this
      self.$refs.table.refresh(false)
    },
    setAllStatus(status) {
      let self = this
      setContentAllStatus({
        ids: self.selectedRowKeys,
        status: status
      }).then(res => {
        self.$message.success('设置成功')
        self.$refs.table.refresh(false)
      })
    },

    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    onRankChange(key, dataIndex, value) {
      let self = this
      setContentRank({
        id: key,
        rank: value
      })
        .then(res => {
          self.$refs.table.refresh(false)
        })
        .catch(err => {
          self.$message.error(err.data.msg)
        })
    }
  }
}
</script>


<style scoped>
.custom-filter-dropdown {
  padding: 8px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
.bage1 {
  color: green !important;
}
</style>
